import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/Scenarios'

export const SCENARIOS_REQUEST_ASYNC = createAsyncTypes('SCENARIOS_REQUEST', typeKey)

export const CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC = createAsyncTypes(
  'CREATE_CAMPAIGN_FROM_SCENARIO',
  typeKey
)

export const LANGUAGES_FILTER_CHANGE = 'AwarenessCenter/Scenarios/LANGUAGES_FILTER_CHANGE'
export const TYPE_FILTER_CHANGE = 'AwarenessCenter/Scenarios/TYPE_FILTER_CHANGE'
export const LEVEL_FILTER_CHANGE = 'AwarenessCenter/Scenarios/LEVEL_FILTER_CHANGE'
export const CREATED_BY_FILTER_CHANGE = 'AwarenessCenter/Scenarios/CREATED_BY_FILTER_CHANGE'
export const CATEGORY_FILTER_CHANGE = 'AwarenessCenter/Scenarios/CATEGORY_FILTER_CHANGE'

export const PAGINATE_CHANGE = 'AwarenessCenter/Scenarios/PAGINATE_CHANGE'
export const SEARCH_CHANGE = 'AwarenessCenter/Scenarios/SEARCH_CHANGE'
export const SEARCH_RESET = 'AwarenessCenter/Scenarios/SEARCH_RESET'

export const DELETE_SCENARIO_ASYNC = createAsyncTypes('DELETE_SCENARIO_ASYNC', typeKey)
export const DUPLICATE_SCENARIO_ASYNC = createAsyncTypes('DUPLICATE_SCENARIO', typeKey)
export const COPY_SCENARIO_ASYNC = createAsyncTypes('COPY_SCENARIO_ASYNC', typeKey)

export const SORT_PROPERTY_CHANGE = 'AwarenessCenter/Scenarios/SORT_PROPERTY_CHANGE'

export const CATEGORY_OPTIONS_LIST = [
  { value: 1, label: 'Healthcare' },
  { value: 2, label: 'Finance' },
  { value: 3, label: 'Work' },
  { value: 4, label: 'IT / Support' },
  { value: 5, label: 'Online Services' },
  { value: 6, label: 'Day-to-day' },
  { value: 7, label: 'Coupons & Gift cards' },
  { value: 8, label: 'Account Confirmation' },
  { value: 9, label: 'Seasonal / Holidays' },
  { value: 10, label: 'HR' },
  { value: 11, label: 'Payments' },
  { value: 12, label: 'Documents & Invoices' },
  { value: 13, label: 'Other' },
  { value: 14, label: 'Incidents template' },
]
